<template>
	<v-menu
			v-if="item.func"
			:nudge-width="getWidthMenu(item.model.value)"
			:max-width="getWidthMenu(item.model.value)"
			:min-width="getWidthMenu(item.model.value)"
			nudge-bottom="30"
			:close-on-content-click="false"
			transition="slide-x-transition"
			:content-class="contentClass"
			:attach="item.attach"
			bottom
			right
			:left="item.left"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
					v-bind="attrs"
					v-on="on"
					icon
					x-small
					class="mr"
			>
				<svg-sprite width="16" height="16" icon-id="filter"></svg-sprite>
			</v-btn>
		</template>
		<v-list class="filterListItems">
			<v-list-item class="filterListItem">
				<slot></slot>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: "FilterDropDown",
	props: {
		item: Object,
		contentClass: String
	},
	methods: {
		getWidthMenu(value) {
			// eslint-disable-next-line no-nested-ternary
			return value === 'options' ? 280 : value === 'date' ? 300 : 330;
		},
	}
};
</script>

<style scoped lang="scss">
.filterListItems {
	padding: 0;

	.filterListItem {
		padding: 0;
	}
}

.tableLogs {
	th {
		border-right: none;
		border-bottom: none;
		background: none !important;
	}

	td {
		border-right: none;
		border-bottom: none;
	}
}
</style>
